// routes/config.js
import RegisterPage from '../pages/Register/Register';
import UnauthorizedPage from '../pages/Unauthorized/Unauthorized';
import LoggedOutPage from '../pages/LoggedOutPage/LoggedOutPage';
import UserProfile from '../pages/UserProfile/UserProfile';
import RegisteredPage from '../pages/RegisteredPage/';

export const routes = [
  {
    path: '/register',
    title: 'common:pages.title.register',
    element: RegisterPage,
    protected: false,
  },
  {
    path: '/unauthorized',
    title: 'common:pages.title.unauthorized',
    element: UnauthorizedPage,
    protected: false,
  },
  {
    path: '/logged-out',
    title: 'common:pages.title.logout',
    element: LoggedOutPage,
    protected: false,
  },
  {
    path: '/',
    title: 'common:pages.title.userprofile',
    element: UserProfile,
    protected: true,
  },
  {
    path: '/registered',
    title: 'common:pages.title.registered',
    element: RegisteredPage,
    protected: false,
  },

];